import React from 'react';
import GenericModal from '../../../components/modal/GenericModal';

// Confirmación antes de "Guardar y notificar" en EntrevistaPostulante.jsx
// (30/09/2026, a pedido de Jody): una vez guardada la entrevista no hay
// flujo de edición (el backend siempre inserta un detalle nuevo) y además
// se notifica a los interesados, así que conviene un paso de confirmación
// antes de disparar la acción. Mismo patrón que ConfirmarPostulacionModal.
// `mensaje` es opcional: "Actualizar y notificar" (cambio de entrevistador/fecha de una
// entrevista ya guardada) lo reutiliza con su propio texto.
const ConfirmarGuardarNotificarModal = ({
    toggleModal,
    onContinue,
    mensaje = 'Se guardará la entrevista y se notificará a los interesados. ¿Desea continuar?',
}) => {
    const handleContinue = () => {
        onContinue();
        toggleModal();
    };

    return (
        <GenericModal showModal={toggleModal} titulo="Confirmar" width="480px">
            <div className="modal-body pt-0">
                <p className="mb-0">{mensaje}</p>
            </div>
            <div className="modal-footer justify-content-end">
                <button
                    type="button"
                    className="btn btn-outline-primary generic-button-ficha-outlined"
                    onClick={toggleModal}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-primary generic-button-ficha mr-2"
                    onClick={handleContinue}
                >
                    Continuar
                </button>
            </div>
        </GenericModal>
    );
};

export default ConfirmarGuardarNotificarModal;
